export enum CMPPermissions {
  FullAccess = 'full-access',
  ReadOnly = 'read-only',
  ReadAndWrite = 'read-and-write',
}

export enum CMPResourceGroup {
  SupportSystem = 'support-system',
  SupportSystemIndividual = 'support-system-individual',
  SupportSystemCompany = 'support-system-company',
  CasesIndividual = 'cases-individual',
  CasesCompany = 'cases-company',
  RaiseBilling = 'raise_billing',
  RaiseIncident = 'raise_incident',
  RaiseCase = 'raise_case',
  RaiseRequest = 'raise_request',

  Automation = 'automation',
  AuditLogs = 'audit-logs',

  General = 'general',

  Reports = 'reports',

  RequestsCatalog = 'requests-catalog',

  PublisherUpdates = 'publisher-updates',
  PublisherUpdateTabsMyContracts = 'publisher-update-tabs-my-contracts',

  CmpWithSCU = 'cmp-with-scu',

  MyProjects = 'my-projects',

  CIAM = 'ciam',
}
